import { createReducer } from 'by-react-utils'

type SessionState = {
  +username?: string,
  +role?: string,
  +preview?: boolean,
  +notifications?: {
    name: string,
    page_seen: boolean,
    link: string
  }[],
  initAt?: number,
  +action?: string,
  +fields?: {
    id: string,
    name: string,
    placeholder?: string,
    type: string
  }[],
  +forgotForm: {
    +action?: string,
    +fields?: {
      id: string,
      name: string,
      value: string
    }[],
  },
  +forgot_password: {
    +action?: string,
    +fields?: {
      id: string,
      name: string,
      value: string
    }[],
    method: string
  },
  +menu?: {}[],
  +urls?: {}[],
  +store?: number,
  +picture?: string,
  +challenge?: {
    current: number,
    total: number,
    best: number,
    quizz: number,
    quizzTotal: number,
    results: [],
    rankingIQ: number,
  }
}

export const initialState: SessionState = {
  username: '',
  role: '',
  notifications: [],
  initAt: -1,
  action: '',
  fields: [],
  forgot_password: [],
  forgotForm: [],
  passwordChanged: false,
  menu: [],
  urls: [],
  store: null,
  picture: '',
  challenge: {}
}

export const ActionTypes = {
  CREATE_FORM: 'CREATE_FORM',
  INIT_SESSION: 'INIT_SESSION',
  CLEAR_SESSION: 'CLEAR_SESSION',
  HANDLE_ERRORS: 'HANDLE_ERRORS',
  PASSWORD_CHANGED: 'PASSWORD_CHANGED',
  INIT_CHALLENGE: 'INIT_CHALLENGE',
  EDIT_CHALLENGE: 'EDIT_CHALLENGE',
  EDIT_PICTURE: 'EDIT_PICTURE',
}

export default createReducer(initialState, {
  [ActionTypes.CREATE_FORM]: (state, { action, fields, forgot_password, form}) => ({
    ...state,
    username: '',
    role: '',
    picture:'',
    initAt: -1,
    action,
    fields: [...fields],
    urls: [],
    forgot_password: {...forgot_password},
    forgotForm: form,
    passwordChanged: false,
    store: null,
    challenge: {},
  }),

  [ActionTypes.INIT_SESSION]: (
    state,
    { initAt, username, notifications, form, menu, preview, role, urls, store, picture, challenge}
  ) => ({
    ...state,
    error: null,
    initAt,
    username,
    role,
    store,
    picture,
    forgotForm: form,
    notifications: [...notifications],
    menu: menu,
    passwordChanged: false,
    preview,
    urls: urls,
    challenge
  }),

  [ActionTypes.EDIT_CHALLENGE]: (
    state,
    {challenge}
  ) => ({
    ...state,
    challenge
  }),

  [ActionTypes.EDIT_PICTURE]: (
    state,
    {picture}
  ) => ({
    ...state,
    picture
  }),

  [ActionTypes.CLEAR_SESSION]: (
    state,
    { initAt, username, notifications, menu, preview }
  ) => ({
    ...state,
    error: null,
    username: '',
    role: '',
    picture: '',
    store: null,
    notifications: [],
    menu : [],
    initAt: -1,
    action: '',
    fields: [],
    urls: [],
    forgot_password: [],
    forgotForm: [],
    passwordChanged: false,
    preview,
    challenge: {},
  }),

  [ActionTypes.HANDLE_ERRORS]: (state, { error }) => ({
    ...state,
    error: { ...error }
  }),

  [ActionTypes.PASSWORD_CHANGED]: (state) => ({
    ...state,
    error: null,
    passwordChanged: true
  }),
})



// WEBPACK FOOTER //
// ./src/store/reducers/Session.js